import React, { useEffect, useState, useContext } from 'react'
import industry3 from '../img/merdekaeditdua.gif'
import { useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import * as yup from 'yup'
import {instance, instance2} from '../utils/axiosInstance'
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import translations from '../login/translations'; // Adjust the path as needed
import { LanguageContext } from '../login/LanguageContext';
import { useToast } from '../login/float';


export default function ForgetPassword() {
    const navigate = useNavigate()
    const location = useLocation();
    const { email } = location.state || {}; // Retrieve email from state

    const { language, toggleLanguage } = useContext(LanguageContext); // Access language and toggle function
    const { showToast } = useToast();
  

    const { values, errors, touched, handleSubmit, handleChange, handleBlur, ...formik } = useFormik({
        initialValues: {
            email: email || '',
            code: '',
            password: '',
            passwordConf: '',
        },
        validationSchema: yup.object({
            email: yup
            .string()
            .email(translations[language].emailInvalid)
            .required(translations[language].emailEmpty)
            .test('email-validity', translations[language].emailInvalid, (value) => {
                const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
                return emailRegex.test(value || '')
            }),
                code: yup.string(),
                password: yup.string().required(translations[language].passwordEmpty),
                passwordConf: yup
                    .string()
                    .oneOf([yup.ref('password'), null], translations[language].passwordAndPasswordConf) // Ensures password and confirmation match
                    .required('Password confirmation is required'),
        }),
        validateOnMount: true, // Validate initial values on mount
        onSubmit: async (result) => {
            try {
                const response = await instance2.post('changepassword', result)
                console.log('responseverification1',response)
                console.log('responseverification2',result)
                if(response.status === 'OK'){
                console.log('responseverification',response)
                showToast(translations[language].toastNewPass)
                navigate('/login')
                }else{
                    formik.setErrors({
                        email: translations[language].wrongEmailVerif,
                        code: translations[language].wrongCodeVerif
                    })
                }
            } catch (error) {
                formik.setErrors({
                    email: translations[language].wrongEmailVerif,
                    code: translations[language].wrongCodeVerif
                })
            }
        }
    })

    const [showMessage, setShowMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState(''); // For error handling
    const isVerifDisabled = !values.email || errors.email;

    async function sendEmail(email) {
        try {
          const response = await instance2.post('send-email', { email });
          console.log("Email sent successfully:", response);
          return true; // Return true to indicate success
        } catch (error) {
          console.error('Error sending email:', error);
          return false; // Return false to indicate failure
        }
      }

    const handleSendEmail = async (e) => {
    e.preventDefault(); // Prevents default link navigation
    if (!isVerifDisabled) {
      const success = await sendEmail(values.email); // Await the sendEmail result
      setShowMessage(true); // Show the success message by default
      if (!success) {
        // If email sending failed, show an error message
        setErrorMessage('Failed to send email. Please try again.');
        setShowMessage(false); // Hide success message if it failed
      }
    }
  };
      

      const isSubmitDisabled = 
      !values.code || values.code.length === 0 ||
      values.password !== values.passwordConf || // Password and confirmation must match\
      errors.password || // Password validation errors
      errors.passwordConf; // Password confirmation validation errors\\

      useEffect(() => {
        if (errors.email) {
          formik.setFieldTouched('email', true, false);
        }
      }, [errors.email]);
      

    return (
        <div className="relative w-full h-screen">
            <div className="flex justify-center items-center h-full">
                <form className="w-full mx-auto p-8 rounded-[20px]" noValidate>
                    <div className="flex flex-col mb-4">
                        <label>{translations[language].emailLabel}</label>
                        <input
                            className="border relative bg-gray-100 p-2 border border-black rounded-[20px]"
                            type="text"
                            name="email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                            autoComplete='true'
                        />
                        <small className="text-red-500">{touched.email && errors.email && errors.email}</small>
                    </div>

                    <div className="flex flex-col items-center text-center my-2">
      {/* Send Email Button */}
      <a
        className={`relative justify-center items-center p-3 text-md rounded-[10px] shadow-lg transition-opacity duration-200 
          ${isVerifDisabled ? 'bg-gray-400 cursor-not-allowed text-gray-300' : 'bg-red-500 text-white'}`}
        href="/"
        onClick={handleSendEmail} // Trigger email sending function
      >
        {translations[language].sendVerification}
      </a>

      {/* Success Message */}
      {showMessage && (
        <small className="flex justify-center items-center text-center my-3 text-green-500">
          {translations[language].checkEmailAndSpam}
        </small>
      )}

      {/* Error Message */}
      {errorMessage && (
        <small className="flex justify-center items-center text-center my-3 text-red-500">
          {errorMessage}
        </small>
      )}
    </div>
                    <div className="flex flex-col ">
                        <label>{translations[language].verificationCodeLabel}</label>
                        <input
                            className="border relative bg-gray-100 p-2 border border-black rounded-[20px]"
                            type="text"
                            name="code"
                            onChange={handleChange}
                            value={values.code}
                        />
                        <small className="text-red-500">{touched.code && errors.code && errors.code}</small>
                    </div>
                    

                    {/* Password Input */}
                    <div className="flex flex-col mb-4">
                        <label>{translations[language].passwordLabel}</label>
                        <input
                            className={`border relative bg-gray-100 p-2 border-black rounded-[20px] ${
                                touched.password && errors.password ? 'border-red-500' : ''
                            }`}
                            type="password"
                            name="password"
                            onChange={handleChange}
                            onBlur={formik.handleBlur}
                            value={values.password}
                        />
                        <small className="text-red-500">
                            {touched.password && errors.password && errors.password}
                        </small>
                    </div>

                    {/* Password Confirmation Input */}
                    <div className="flex flex-col mb-4">
                        <label>{translations[language].passwordConfLabel}</label>
                        <input
                            className={`border relative bg-gray-100 p-2 border-black rounded-[20px] ${
                                touched.passwordConf && errors.passwordConf ? 'border-red-500' : ''
                            }`}
                            type="password"
                            name="passwordConf"
                            onChange={handleChange}
                            onBlur={formik.handleBlur}
                            value={values.passwordConf}
                        />
                        {touched.passwordConf && errors.passwordConf && (
                            <small className="text-red-500">{errors.passwordConf}</small>
                        )}
                    </div>

                    <button
  className={`relative w-full py-3 mt-8 ${
    isSubmitDisabled ? 'bg-gray-300 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-500'
  } text-white border rounded-[20px]`}
  type="submit"
  onClick={handleSubmit}
  disabled={isSubmitDisabled} // Disables the button when isSubmitDisabled is true
>
{translations[language].verificationLabel}
</button>
                </form>
            </div>
        </div>
    )
}
